<!-- <h4></h4> -->
<h4 mat-dialog-title style="margin-bottom: 17px;">Please Confirm</h4>
<p>{{ question }}</p>
<div class="btn-row">
	<button mat-raised-button class="no" (click)="cancel()">{{ cancelButtonText }}</button>
	<button mat-raised-button class="yes" (click)="confirm()">{{ confirmationButtonText }}</button>
</div>